module.exports = __webpack_public_path__ + "static/media/test-icon.0aa87d11.svg";